
  export default {
    //  隐私条款-sdk清单页面
    name: 'YstkSDK',
    components: {},
    head() {
      return {
        title: '',
        meta: [
          {
            name: 'keywords',
            content: '问卷调查，调查问卷，网络调查，市场调查，市场调研，问卷，问卷网，表单设计，报名表，登记表',
          },
          {
            name: 'description',
            content:
              '问卷免费网络调查平台拥有创新的编辑界面和结果分析界面，海量的问卷和表单模板，支持十余种常见题型和多种问卷发布渠道。专注于为企业和个人提供问卷表单的创建，发布，管理，收集及分析服务。',
          },
          {
            'http-equiv': 'Content-Type',
            content: 'text/html; charset=utf-8',
          },
          {
            name: 'viewport',
            content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover',
          },
          {
            name: 'progam',
            content: 'no-cache',
          },
          {
            name: 'Cache-Control',
            content: 'no-transform',
          },
          {
            name: 'Cache-Control',
            content: 'no-siteapp',
          },
        ],
      }
    },
  }
